/**
 * Environment names: `prod` is the one deployed environment (wrangler.toml `[env.prod]`);
 * `local` is the hermetic test / e2e stack (top-level wrangler config), not a deployment.
 */
export const Envs = ['local', 'prod'] as const;
export type Env = (typeof Envs)[number];

export function isEnv(value: string | undefined): value is Env {
  return (Envs as readonly string[]).includes(value ?? '');
}

/**
 * Public hosts (docs/01 §3). prod answers on exactly these; the apex `acapella.lol` serves the
 * same SPA as `app.` and the WP1.9b `-dev` names still resolve as legacy aliases.
 */
export const PUBLIC_HOSTS = {
  web: 'app.acapella.lol',
  tv: 'tv.acapella.lol',
  cms: 'cms.acapella.lol',
  api: 'api.acapella.lol',
  media: 'media.acapella.lol',
} as const;

/** API path prefix (WP0.1: every endpoint is mounted under `/v1`). */
export const API_PREFIX = '/v1';

/** Header carrying the device id on pairing-related requests (docs/07 §3). */
export const DEVICE_HEADER = 'X-Akapella-Device';
/** Request id echoed by the API for log correlation (WP0.1). */
export const REQ_ID_HEADER = 'X-Req-Id';
